import React from "react";
import { Link } from "react-router-dom"; // Usando Link do React Router
import "../styles/product.css";

import accessorios from "../assets/images/Produtos/acessorios.jpg";
import antenas_rfs from "../assets/images/Produtos/antenas_rfs.jpg";
import cabos from "../assets/images/Produtos/cabos.jpg";
import filmes_poliester from "../assets/images/Produtos/filmes_poliester.png";
import fitas_adesivas from "../assets/images/Produtos/fitas_adesivas.png";
import fitas_isolantes from "../assets/images/Produtos/fitas_isolantes.png";
import isolantes from "../assets/images/Produtos/isolantes.jpg";
import papeis_isolantes from "../assets/images/Produtos/papeis_isolantes.jpg";
import radio from "../assets/images/Produtos/radio.png";
import termolaminacao from "../assets/images/Produtos/termolaminacao.jpg";

const productsData = [
  { name: "FILMES DE POLIÉSTER", image: filmes_poliester, category: "filmes_poliester" },
  { name: "FILMES PARA TERMOLAMINAÇÃO", image: termolaminacao, category: "termolaminacao" },
  { name: "CABOS", image: cabos, category: "cabos" },
  { name: "CONECTORES E ACESSÓRIOS", image: accessorios, category: "acessorios" },
  { name: "ANTENAS RFS", image: antenas_rfs, category: "antenas_rfs" },
  { name: "RÁDIO", image: radio, category: "radio" },
  { name: "FITAS ADESIVAS INDUSTRIAIS", image: fitas_adesivas, category: "fitas_adesivas" },
  { name: "FITAS ADESIVAS ISOLANTES", image: fitas_isolantes, category: "fitas_isolantes" },
  { name: "ISOLANTES", image: isolantes, category: "isolantes" },
  { name: "PAPÉIS ISOLANTES", image: papeis_isolantes, category: "papeis_isolantes" },
];

const Products = () => {
  return (
    <div className="products-container">
      <h1 className="heading">Nossos Produtos</h1>
      <div className="products-grid">
        {productsData.map((product, index) => (
          <div key={index} className="product-card">
            <Link to={`/produtos/${product.category}`}>
              <img
                src={product.image}
                alt={product.name}
                className="product-image clickable"
              />
            </Link>
              <h4 className="product-name">{product.name}</h4>
          </div>
        ))}
      </div>
    </div>
  );
};


export default Products;
